module.exports = __webpack_public_path__ + "account/assets/ref-loading-icon-white.fa90d87a.svg";